<template>
    <div class="CreateParticipantTabDiv">
      <div class="container-fluid">
          <div class="row margin-Top-2Perc margin-bottom-2Perc margin-left-0point3Perc grey-border">
              <div class="col-md-2 col-lg-4 font-size-18px padding-top-bottom-point-7Perc cursor-pointer padding-Left-0px padding-right-0px" v-bind:class="{'background-gray': isActive === 1 }" v-on:click="renderCreateParticipantUI($event,1)">
                Single Participant
              </div>
              <div class="left-border col-md-5 col-lg-4 font-size-18px padding-top-bottom-point-7Perc cursor-pointer padding-Left-0px padding-right-0px" v-bind:class="{'background-gray': isActive === 2}" v-on:click="renderCreateParticipantUI($event,2)">
                Multiple Participants using CSV template
              </div>    
              <!--  -->
              <div class="left-border col-md-5 col-lg-4 font-size-18px padding-top-bottom-point-7Perc cursor-pointer padding-Left-0px padding-right-0px" v-bind:class="{'background-gray': isActive === 3}" v-on:click="renderCreateParticipantUI($event,3)">
                Multiple Participants using GCC CSV template
              </div>
              <!--  -->
          </div>      
      </div>
      <!-- Start of Create Single Participant UI-->  
      <create-single-participant v-if="isActive === 1"></create-single-participant>  
      <!-- End of Create Single Participant UI-->
      <!-- Start of Create Multiple Participants UI-->  
      <create-multiple-participants v-if="isActive === 2"></create-multiple-participants>  
      <!-- End of Create Multiple Participants UI-->                
      <create-multiple-participants-UsingGCC-CSV v-if="isActive === 3"></create-multiple-participants-UsingGCC-CSV>
    </div>    
</template>

<script>
import CreateSingleParticipant from '@/components/CreateSingleParticipant'
import CreateMultipleParticipants from '@/components/CreateMultipleParticipants'
import CreateMultipleParticipantsUsingGCCCSV from '@/components/CreateMultipleParticipantsUsingGCCCSV'
export default {
  data: function () {
    return {
      isActive: 1
    }
  },
  components: {
    'create-single-participant': CreateSingleParticipant,
    'create-multiple-participants': CreateMultipleParticipants,
    'create-multiple-participants-UsingGCC-CSV': CreateMultipleParticipantsUsingGCCCSV
  },
  methods: {
    renderCreateParticipantUI: function (event, flagToUpdate) {
      this.isActive = flagToUpdate
      this.$emit('clickedTab', flagToUpdate)
    }
  },
  name: 'CreateParticipantTabDiv'
}
</script>

<style scoped>
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.background-color-red {
  background-color: red;
}
.border-black {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}

.font-size-18px {
  font-size: 17px;
}
.background-gray {
  background-color: #ddd;
}
.padding-top-bottom-point-7Perc {
  padding-top: 0.7% !important;
  padding-bottom: 0.7% !important;
}
.margin-left-1Perc
{
  margin-left:1%;
}
.margin-left-0point3Perc
{
  margin-left:0.3%;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateParticipantTab.vue